module.exports = __webpack_public_path__ + "img/skill.f3395a86.svg";